import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Typography, Spin, Tabs, Button } from 'antd';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import Orders from '../components/orders/list/List';
import EmptyOrders from '../components/orders/list/EmptyOrders';

import * as activeOrdersConst from '../constants/activeOrders';

const { Title } = Typography;

const OrdersPage = ({ setShowOnMap }) => {
  
  const [loading, setLoading] = useState(null);
  const [selectedTab, setSelectedTab] = useState(1);
  const [createdOrders, setCreatedOrders] = useState(null);
  const [activeOrders, setActiveOrders] = useState(null);
  const [pausedOrders, setPausedOrders] = useState(null);

  useEffect(() => {
    fetchList();
  }, [selectedTab]);

  const fetchList = async () => {
    setLoading(true);
    setCreatedOrders(null);
    setActiveOrders(null);
    try {
      const { data, status } = await axios.get(`${process.env.REACT_APP_API_URL}/orders/`, {
        headers: {
          Authorization: `JWT ${window.localStorage.getItem('access')}`
        }
      });
      setLoading(false);
      const sorted = data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      if (status === 200) {
        setCreatedOrders(sorted.filter(item => item.status === activeOrdersConst.CREATED));
        setActiveOrders(sorted.filter(item => item.status === activeOrdersConst.ACTIVE || item.status === activeOrdersConst.COMPLETED));
        setPausedOrders(sorted.filter(item => item.status === activeOrdersConst.REMOVED));
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onChange = (item) => {
    setSelectedTab(item);
  }
  
  return (
    <div className='orders'>
      <Tabs
        defaultActiveKey={selectedTab}
        onChange={onChange}
        items={[
          {
            label: 'Созданные',
            key: '1',
            children: <>
              {createdOrders && createdOrders.length > 0 && <Orders orders={createdOrders} fetchList={fetchList} setLoading={setLoading} />}
              {createdOrders && createdOrders.length === 0 && <EmptyOrders />}
            </>,
          },
          {
            label: 'Активные',
            key: '2',
            children: <>
              {activeOrders && activeOrders.length > 0 && <Orders orders={activeOrders} fetchList={fetchList} setLoading={setLoading} />}
              {activeOrders && activeOrders.length === 0 && <EmptyOrders />}
            </>,
          },
          {
            label: 'На паузе',
            key: '3',
            children: <>
              {pausedOrders && pausedOrders.length > 0 && <Orders orders={pausedOrders} fetchList={fetchList} setLoading={setLoading}  />}
              {pausedOrders && pausedOrders.length === 0 && <EmptyOrders />}
            </>
          },
        ]}
      />
      {loading && <Spin
        indicator={
          <LoadingOutlined
            style={{
              fontSize: 32,
            }}
            spin
          />
        }
      />}
    </div>
  )
};

export default OrdersPage;